import styled from "styled-components";

export const Container = styled.button`
  background-color: #EB5A00;
  border: 0 none;
  border-radius: 500px;
  box-shadow: 0px 0px 24px 0px #EB5A009E;
  color: #FFFFFF;
  cursor: pointer;
  padding: 10px 32px;
  white-space: nowrap;
  width: 100%;

  &:hover {
    background-color: #FF6200;
    box-shadow: 0px 0px 24px 0px #FF62009E;
  }

  &:disabled {
    background-color: #EB5A00C0;
    cursor: not-allowed;
  }
`